import React from 'react';

const About = () => {
	return (
    <section className="max-w-7xl mx-auto min-h-[70vh]">
      <div className="flex justify-center">
        <div className=" my-24 -rotate-12">
          <h1 className="bg-red-600 p-4 rounded-lg font-bold text-5xl text-white">
            Comming
          </h1>
          <h1 className="bg-green-600 p-4 mt-1 text-right font-bold text-5xl rounded-lg  text-white">
            Soon...
          </h1>
        </div>
      </div>
    </section>
  );
};

export default About;